<template>
  <div class="container">
    <text-with-image-inline
      :title_tag="title_tag"
      text_centered
      title_pre_wrap
      :title="title"
      :content="content"
      :lazy_img_src="lazy_img_src"
      :img_src="img_src"
      :button_link="button_link"
      :button_text="button_text"
      :button_green="button_green"
      :title_on_center="get_title_on_center"
      :img_border_radius="img_border_radius"
      :img_right="image_from_right"
      :title_upper_case="title_upper_case"
      :mobile_image_from_top="mobile_image_from_top"
      :mobile_image_from_bottom="mobile_image_from_bottom"
    />
  </div>
</template>

<script>

import TextWithImageInline from "../parts/builder/TextWithImageInline.vue";
import {mapGetters} from "vuex";

export default {
  name: "TextWithImage",
  components: {TextWithImageInline},
  props: {
    /**props**/
    img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    lazy_img_src: {
      type: String,
      default: '',
      admin_type: 'image',
    },
    img_border_radius: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title: {
      type: String,
      default: '',
      admin_type: 'textarea',
    },
    title_tag: {
      type: String,
      default: 'h1',
      admin_type: 'select',
      admin_data_values: [
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6'
      ],
    },
    title_upper_case: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    content: {
      type: String,
      default: '',
      required: true,
      admin_type: 'editor',
    },
    button_text: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    button_link: {
      type: String,
      default: '',
      admin_type: 'input',
    },
    button_green: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_on_center: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    title_on_center_mobile: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    image_from_right: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    mobile_image_from_top: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    mobile_image_from_bottom: {
      type: Boolean,
      default: false,
      admin_type: 'checkbox',
    },
    /**props**/
  },
  computed: {
    ...mapGetters([
      'getIsMobile'
    ]),
    get_title_on_center() {
      if (!this.getIsMobile) {
        return this.title_on_center
      }
      return this.title_on_center_mobile ? this.title_on_center_mobile : this.title_on_center
    }
  }
}
</script>
